export const widgetDefaults = {
  pageName: 'booking_form_widget',
};

export const WIDGET_NAME = 'bookings_form';

export const intakeFormsClickDefaults = {
  component: 'waiver form',
  action: 'click',
  value: 'fill form',
  pageName: WIDGET_NAME,
};

export const intakeFormsErrorDefaults = {
  component: 'waiver form',
  action: 'error',
  pageName: WIDGET_NAME,
};

export const intakeFormsErrorSuffixes = {
  FIELD_CHANGE: ' - field change',
  BOOK_NOW: ' - book now',
};
